<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <header :drawer="$store.state.drawer"></header>
        <Sidebar :drawer="$store.state.drawer"></Sidebar>
        <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> 
        <span class="child">/ VUNET Fees Report </span>
    </v-row>
        <br />
        <v-card class="card">
            <v-card-title class="heading justify-center">VUNET Fees Report</v-card-title>
            <v-toolbar  flat dense v-if="fees_details.length > 0">
                <download-excel
            v-if="bookList1.length > 0"
            class="mr-2 pb-3 pt-2"
            :data="bookList1"
            :fields="table_fields"
            worksheet="VUNET_Fees_Report"
            name="VUNET_Fees_Report.xls"
            >
            <v-btn color="success" outlined rounded>
                <v-icon dark>mdi-file-excel</v-icon> Export
            </v-btn>
            </download-excel>
            </v-toolbar>
            <br>
            <v-card-text>
                 <v-data-table
          v-if="bookList1.length > 0"
          dense
          :headers="headers"
          :items="bookList1"
          :search="search"
          class="elevation-1 mytable nowrap"
          @current-items="getFiltered"
        >
        <!-- <v-data-table :headers="headers" :items="fees_details" class="elevation-1 nowrap" :search="search"> -->
            <template v-slot:top>
                
                <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete
                            class="mr-2 pb-5 pt-2"
                            flat
                            hide-details
                            small
                            rounded
                            dense
                            outlined
                            color="#0F2027"
                            :label="header.text"
                            multiple
                            clearable
                            :items="columnValueList(header.value)"
                            v-model="filters[header.value]"
                          ></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
            </template>
            
           
        </v-data-table>
            </v-card-text>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    import Header from "../shared/Header";
    import Sidebar from "../shared/Sidebar";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            components: {
            Header: Header,
            Sidebar: Sidebar,
        },
            overlay: false,
            
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            org: "",
            status: "",
            dialog: false,
            filterArr: [],
            filters: {
                paymenttransactionstatus: [],
                program: [],
                stream: [],
                examdate:[],
                email:[],
            },
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Learner",
                    align: "left",
                    sortable: false,
                    value: "learner",
                },
                {
                    text: "Program",
                    align: "left",
                    sortable: false,
                    value: "program",
                },
                {
                    text: "Stream",
                    align: "left",
                    sortable: false,
                    value: "stream",
                },
                {
                    text: "Learner Application",
                    align: "left",
                    sortable: false,
                    value: "learnerapplication",
                },
                {
                    text: "Application Date",
                    align: "left",
                    sortable: false,
                    value: "learnerapplication_date",
                },
                {
                    text: "Exam Date",
                    align: "left",
                    sortable: false,
                    value: "examdate",
                },
                {
                    text: "Transaction ID",
                    align: "left",
                    sortable: false,
                    value: "transactionID",
                },
                {
                    text: "Transaction Date",
                    align: "left",
                    sortable: false,
                    value: "transactionDate",
                },
                {
                    text: "Orderid",
                    align: "left",
                    sortable: true,
                    value: "orderid",
                },
                { text: "Amount",
                  value: "amount",
                  align: "left",
                  sortable: true,
                },
                { text: "Payment Transaction Status",
                  value: "paymenttransactionstatus",
                  align: "left",
                  sortable: true,
                },
                { text: "City",
                  value: "city",
                  align: "left",
                  sortable: true,
                },
                { text: "Email",
                  value: "email",
                  align: "left",
                  sortable: true,
                },
                { text: "Mobile",
                  value: "mobile",
                  align: "left",
                  sortable: true,
                },
            ],
            table_fields: 
            {

                'Sr. No':'srno',
                'Student Name':'learner',
                'Program':'program',
                "Stream":'stream',
                'Learner Application':'learnerapplication',
                'Application Date':'learnerapplication_date',
                'Exam Date':'examdate',
                'Transaction ID':'transactionID',
                'Transaction Date':'transactionDate',
                "Orderid":'orderid',
                "Amount":'amount',
                "Payment Transaction Status":'paymenttransactionstatus',
                "City":'city',
                "Email":'email',
                "Mobile":'mobile',
        },
            fees_details: [],
            payment_trnasaction_status: [],
        }),

        computed: {
            bookList1() {
            return this.fees_details.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
            },
        },

        watch: {
            
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },
        methods: {
            getFiltered(e) {
                this.filterArr = e;
                },
                columnValueList(val) {
                return this.fees_details.map((d) => d[val]);
                },
           
            onLoad() {
                this.overlay = true;
                axios
                    .post("/VunetMaster/getFeesDetailsReport")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //window.alert(res.data.msg)
                            
                                this.overlay = false;
                                this.fees_details = res.data.fees_details;
                                this.payment_trnasaction_status = res.data.payment_trnasaction_status;
                            
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            getfilteredrow(){
                alert(this.status)
                for (let index = 0; index < this.fees_details.length; index++) {
                   
                    if (this.fees_details[index].status != this.status) {
                        this.fees_details.splice(index,1);
                    }
                    
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }

    .mytable /deep/ thead th {
    
    color: rgb(26, 19, 19) !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
   

</style>
